/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "#/lib/social-signal-api-client.ts"
import type {
  RequestConfig,
  ResponseErrorConfig,
} from "#/lib/social-signal-api-client.ts"
import type { SignoutMutationResponse, Signout401 } from "../types/Signout.ts"
import { signoutMutationResponseSchema } from "../zod/signoutSchema.ts"

function getSignoutUrl() {
  const res = { method: "POST", url: `/auth/token/invalidate` as const }
  return res
}

/**
 * @description Sign out
 * @summary Invalidate an active access token
 * {@link /auth/token/invalidate}
 */
export async function signout(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    SignoutMutationResponse,
    ResponseErrorConfig<Signout401>,
    unknown
  >({ method: "POST", url: getSignoutUrl().url.toString(), ...requestConfig })
  return signoutMutationResponseSchema.parse(res.data)
}
